<template>
  <div>
    <div class="banner_box">
     <joinmainbanner></joinmainbanner>
    </div>
    <div class="join_box">
      <joinpartcontent></joinpartcontent>
    </div>
  </div>
</template>

<script>
  import joinpartcontent from "@/components/contentcoms/indexcontentcoms/joinpartcontent";
  import joinmainbanner from "@/components/contentcoms/joincontentcoms/joinmainbanner";
  export default {
    name: "joincontent",
    components: {joinmainbanner, joinpartcontent}
  }
</script>

<style scoped>
  .join_box{
    margin: 0 auto;
    width: 1200px;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/joincontent.vue